@let type = $type();
@let endTooltipWhenDisabled = $disabled() ? $tooltipWhenDisabled() : t(type === 'date' ? 'must_select_start_date' : 'must_select_start_date_time')();
<div class="flex" [class.flex-col]="$vertical()" [style.gap]="$hostGap() | cssValue">
  <app-date-picker
    [type]="type"
    [seconds]="$seconds()"
    [isDisabled]="$disabled()"
    [value]="$startDateValue()"
    [min]="$startMin()"
    [max]="$startMax()"
    [placeholder]="$startPlaceholder()"
    [label]="$translations().$startLabel()"
    [labelFontSize]="$labelsFontSize()"
    [inputFontSize]="$inputsFontSize()"
    [labelWeight]="$labelsWeight()"
    [labelColor]="$labelsColor()"
    [gap]="$gap()"
    [tooltipWhenDisabled]="$tooltipWhenDisabled()"
    [hostWidth]="$hostWidth()"
    [inputWidth]="$inputWidth()"
    [controlPosition]="$controlPosition()"
    [verticalAlignment]="$verticalAlignment()"
    (valueChange)="onValueChange(true, $event)"
  />
  <app-date-picker
    [type]="type"
    [seconds]="$seconds()"
    [isDisabled]="$endDisabled()"
    [value]="$endDateValue()"
    [min]="$endMin()"
    [max]="$endMax()"
    [placeholder]="$endPlaceholder()"
    [label]="$translations().$endLabel()"
    [labelFontSize]="$labelsFontSize()"
    [inputFontSize]="$inputsFontSize()"
    [labelWeight]="$labelsWeight()"
    [labelColor]="$labelsColor()"
    [gap]="$gap()"
    [tooltipWhenDisabled]="endTooltipWhenDisabled"
    [hostWidth]="$hostWidth()"
    [inputWidth]="$inputWidth()"
    [controlPosition]="$controlPosition()"
    [verticalAlignment]="$verticalAlignment()"
    (valueChange)="onValueChange(false, $event)"
  />
</div>
